'use client';
import {
  createContext,
  PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from 'react';

import { RealTimeService } from '../helpers/RealTimeService';
import { useCommonStore } from '@/store';

export enum ConnectionStatus {
  Disconnected = 'DISCONNECTED',
  Public = 'PUBLIC',
  Private = 'PRIVATE',
}

const RealTimeContext = createContext<{ status: ConnectionStatus }>({
  status: ConnectionStatus.Disconnected,
});

export const useRealTimeStatus = () => useContext(RealTimeContext);

export const RealTimeProvider = ({ children }: PropsWithChildren) => {
  const [status, setStatus] = useState(ConnectionStatus.Disconnected);

  const playerSettings = useCommonStore.use.playerSettings();
  const pendingPlayerSettings = useCommonStore.use.pendingPlayerSettings();

  useEffect(() => {
    if (!playerSettings || pendingPlayerSettings) {
      return;
    }

    const realTimeService = RealTimeService.getInstance();

    if (playerSettings.cent.user) {
      realTimeService.connect(playerSettings);
      setStatus(ConnectionStatus.Private);
    } else {
      realTimeService.connect(playerSettings);
      setStatus(ConnectionStatus.Public);
    }

    return () => {
      realTimeService.disconnect();
      setStatus(ConnectionStatus.Disconnected);
    };
  }, [playerSettings, pendingPlayerSettings]);

  return (
    <RealTimeContext.Provider value={{ status }}>
      {children}
    </RealTimeContext.Provider>
  );
};
